module.exports = __webpack_public_path__ + "static/media/kim-lose.a7c7f73e.png";